import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Alert,
    Card,
    CardBody,
    CardHeader,
    Container,
    Spinner
} from "reactstrap";

import GroupService from "../Services/GroupService";
import { CoordinatorDto, GroupFormData, UpdateGroupDto } from "../types/Group";
import GroupForm from "./GroupForm";


const EditGroupPage = () => {

    const { groupId } = useParams();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");
    const [coordinators, setCoordinators] =
        useState<CoordinatorDto[]>([]);
    const [group, setGroup] =
        useState<GroupFormData | null>(null);

    useEffect(() => {

        if (groupId) {

            loadGroup(groupId);

        }

    }, [groupId]);
    useEffect(() => {

        GroupService.getCoordinators()
            .then(setCoordinators);

    }, []);
    const loadGroup = async (
        id: string
    ) => {

        try {

            const response =
                await GroupService.getById(id);



         setGroup({

    groupName: response.groupName,
    type: response.type,
    category: response.category,

    shortDescription: response.shortDescription,
    longDescription: response.longDescription,
    syllabus: response.syllabus,

    amount: response.amount,

    region: response.region,
    state: response.state,
    district: response.district,

    language: response.language,

    isPaymentRequired: response.isPaymentRequired,
    groupPayment: response.groupPayment,

    notificationBanner: response.notificationBanner,

    isActive: response.isActive,

    coordinatorIds: []

});

        }
        catch {

            setError(
                "Unable to load group."
            );

        }
        finally {

            setLoading(false);

        }

    };

    const handleSubmit = async (
        data: UpdateGroupDto
    ) => {

        if (!groupId)
            return;

        try {

            await GroupService.update(
                groupId,
                data
            );

            navigate("/admin/groups");

        }
        catch {

            setError(
                "Failed to update group."
            );

        }

    };

    if (loading)
        return (
            <Container className="text-center mt-5">
                <Spinner />
            </Container>
        );

    if (!group)
        return (
            <Container className="mt-5">
                <Alert color="danger">
                    {error || "Group not found."}
                </Alert>
            </Container>
        );

    return (

        <Container className="mt-4">

            <Card>

                <CardHeader>

                    <h4 className="mb-0">
                        Edit Group
                    </h4>

                </CardHeader>

                <CardBody>

                    {
                        error &&
                        <Alert color="danger">
                            {error}
                        </Alert>
                    }

                    <GroupForm
                        initialValues={group}
                        coordinators={coordinators}
                        onSubmit={handleSubmit}
                        isEdit={true}
                    />

                </CardBody>

            </Card>

        </Container>

    );

};

export default EditGroupPage;